import {
  ApiClientError,
  CreateBillingPortalSessionResponse,
} from '@raydiant/api-client-js';
import raydiant from '../clients/raydiant';
import useProtectedMutation from './useProtectedMutation';

export default function useCreateBillingPortalSession() {
  return useProtectedMutation<
    CreateBillingPortalSessionResponse,
    ApiClientError,
    string
  >(async (accountId: string) => {
    const response = await raydiant.createBillingPortalSession(accountId);
    return response;
  });
}
